import sanitizeHtml from 'sanitize-html';

type Options = { allowedTags?: string[]; allowedAttributes?: any; allowedIframeHostnames?: string[] };

const defaultOptions = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'br'],
  allowedAttributes: {
    a: ['href'],
    ul: ['class'],
    h1: ['class'],
    h2: ['class'],
    h3: ['class'],
    h4: ['class'],
    h5: ['class'],
    h6: ['class'],
  },
  allowedIframeHostnames: ['www.youtube.com'],
};

const sanitize = (dirty: string, options?: Options) => ({
  __html: sanitizeHtml(dirty, {
    ...defaultOptions,
    allowedTags: options?.allowedTags
      ? [...defaultOptions.allowedTags, ...options.allowedTags]
      : defaultOptions.allowedTags,
    allowedAttributes: options?.allowedAttributes
      ? {
          ...defaultOptions.allowedAttributes,
          ...options.allowedAttributes,
        }
      : defaultOptions.allowedAttributes,
    allowedIframeHostnames: options?.allowedIframeHostnames
      ? [...defaultOptions.allowedTags, ...options.allowedIframeHostnames]
      : defaultOptions.allowedIframeHostnames,
  }),
});

export const SanitizeHTML = ({ html, options }: { html: string; options?: Options }) => (
  <div dangerouslySetInnerHTML={sanitize(html, options)} />
);